<template>
    <div class="case-warp">
        <!-- 筛选-->
        <div class="screen-panel">
            <!-- <div class="total">
                <p>全国案例：</p>
                <p>{{ oTotalNum.total || '&#45;&#45;' }}户</p>
            </div>-->
            <div class="condition" @click="toCondition">
                <span>按条件搜索</span>
                <img :class="['triangle',{'triangle_triangle':isShowCondition}]"
                     src="@/assets/images/project/v3/triangle.png"></img>
            </div>
            <div class="area" @click="toArea">
                <span>{{ nCity || '--' }}</span>
                <img class="triangle" src="@/assets/images/project/v3/triangle.png"></img>
            </div>
            <div class="cut" @click="cutMode">
                <span>{{ mode == 0 ? '地图' : '列表' }}</span>
                <div v-if="mode == 0" class="map-icon"></div>
                <div v-else class="list-icon"></div>
            </div>
        </div>
        <!-- 案例列表 -->
        <div v-show="mode == 0" ref="list" class="list-panel">
            <van-pull-refresh v-model="isRefreshing" @refresh="onListRefresh">
                <van-list
                    v-model="isloading"
                    :offset="50"
                    direction="down"
                    :finished="isfinished"
                    :immediate-check="false"
                    @load="onListLoad"
                >
                    <div class="list van-clearfix">
                        <template v-for="(item,index) in arrCaseList">
                            <div class="case" @click="toCase(item)">
                                <div :class="['status',{'status-light':item.status == '已完工'}]">
                                    {{ item.status }}
                                </div>
                                <!-- <img v-if="item.project_uuid" src="@/assets/images/koub-icon2.png" class="koub-icon"
                                     alt="">-->
                                <div class="icon-box">
                                    <div v-if="item.project_uuid" class="orange-icon">口碑</div>
                                    <div v-if="item.well_chosen == 1" class="red-icon">精选</div>
                                </div>
                                <div class="title">
                                    {{ item.type }} | {{ item.city + item.community_name + "项目案例" }}
                                </div>
                                <div class="info">
                                    <p>{{ item.house_area }}</p>
                                    <p>{{ item.house_cate || "暂无" }}</p>
                                    <img src="@/assets/images/project/v3/look.png" alt=""/>
                                    <p>{{ item.real_views || 100 }}</p>
                                </div>
                                <div class="images">
                                    <div class="pic-item" v-for="(imgItem, imgIndex) in item.images"
                                         :key="imgIndex">
                                        <img v-lazy="imgItem.img_url" alt="" v-if="imgIndex <= 2"/>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-if="arrAllCaseList.length > 0">
                            <div class="more-title">
                                更多周边案例
                            </div>
                            <template v-for="(item,index) in arrAllCaseList">
                                <div class="case" @click="toCase(item)">
                                    <div :class="['status',{'status-light':item.status == '已完工'}]">{{
                                            item.status
                                        }}
                                    </div>
                                    <img v-if="item.project_uuid" src="@/assets/images/koub-icon2.png" class="koub-icon"
                                         alt="">
                                    <div class="title">
                                        {{ item.type }} | {{ item.city + item.community_name + "项目案例" }}
                                    </div>
                                    <div class="info">
                                        <p>{{ item.house_area }}</p>
                                        <p>{{ item.house_cate || "暂无" }}</p>
                                        <img src="@/assets/images/project/v3/look.png" alt=""/>
                                        <p>{{ item.real_views || 100 }}</p>
                                    </div>
                                    <div class="images">
                                        <div class="pic-item" v-for="(imgItem, imgIndex) in item.images"
                                             :key="imgIndex">
                                            <img v-lazy="imgItem.img_url" alt="" v-if="imgIndex <= 2"/>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                    <template #finished>
                        <div v-if="arrCaseList.length > 0 || arrAllCaseList.length > 0">
                            没有更多了
                        </div>
                    </template>
                </van-list>
            </van-pull-refresh>
        </div>
        <!-- 案例地图 -->
        <div v-show="mode == 1" class="map-panel">
            <div class="nav-column" v-if="arrNav.length!=0">
                <ul>
                    <div class="nav-list" v-for="(item, index) in arrNav" :key="index">
                        <div class="line-nav" v-if="index != 0"></div>
                        <li :class="item.open ? item.className : ''" @click="navChange(index)">
                            <div :class="[item.iconName]"></div>
                            <div class="nav-text">
                                <p class="num">
                                    <span>{{ item.oTotalNum }}</span>户
                                </p>
                                <p :class="`state-${index + 1}`">{{ item.name }}</p>
                            </div>
                        </li>
                    </div>
                </ul>
            </div>
            <div id="container" class="case-map"></div>
            <div :class="['list-panel',{'list-unfold':isUnfoldMapList}]">
                <div class="unfold-btn" @click="toMapList">
                    <div :class="['arrow-icon',{'arrow-icon2':isUnfoldMapList}]"></div>
                </div>
                <div class="list_box">
                    <template v-for="(item,index) in mapCaseList">
                        <div class="case" @click="toCase(item)">
                            <div :class="['status',{'status-light':item.status == '已完工'}]">{{ item.status }}</div>
                            <img v-if="item.project_uuid" src="@/assets/images/koub-icon2.png" class="koub-icon" alt="">
                            <div class="title">
                                {{ item.type }} | {{ item.city + item.community_name + "项目案例" }}
                            </div>
                            <div class="info">
                                <p>{{ item.house_area }}</p>
                                <p>{{ item.house_cate || "暂无" }}</p>
                                <img src="@/assets/images/project/v3/look.png" alt=""/>
                                <p>{{ item.real_views || 100 }}</p>
                            </div>
                            <div class="images">
                                <div class="pic-item" v-for="(imgItem, imgIndex) in item.images"
                                     :key="imgIndex">
                                    <img v-lazy="imgItem.img_url" alt="" v-if="imgIndex <= 2"/>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <!--通知icon-->
        <div v-if="isZxy" class="tips-icon" @click="toListTips">
            <img src="@/assets/images/antV2/tips2.png" alt="">
            <span class="tips-num" v-if="nTipsNum">{{ nTipsNum > 99 ? '99+' : nTipsNum }}</span>
        </div>

        <!-- 筛选弹框 -->
        <Screen :show="isShowCondition" @onCondition="onCondition"></Screen>
        <!-- 地址选择 -->
        <!--        <awesome-picker ref="picker" :data="arrCityList" :colorConfirm="oPicker.colorConfirm"-->
        <!--                        @confirm="confirmCity" @cancel="cancelCity"></awesome-picker>-->

        <van-popup v-model="isSelectCity" round position="bottom" @click-overlay="toArea">
            <van-cascader
                v-model="nSelectCity"
                title="请选择所在地区"
                active-color="#133D8D"
                :options="arrCityList"
                @close="toArea"
                @finish="confirmCity"
            />
            <div class="safe-area"></div>
        </van-popup>
    </div>
</template>

<script>

// import vConsole from '@/libsV2/vconsole.js'
// import {getWxSingleConfig, wxGetLocationH5, geoGetLocation} from "@/js/wx.js";
import {wxGetLocationH5, geoGetLocation, geoGetAddress} from "@/js/wx.js";
import MapLoader from "@/libs/AMap.js";
import loadJs from "@/libs/loadjs.js";
import {
    getCaseList,
    getAllCaseList,
    getMapData,
    getMapPlots,
    getMapList,
    checkZxy,
    getTipsNum,
    shareNum,
    readNum,
    getTree
} from "@/js/project/v3/index.js";

import Screen from '../components/screen/index.vue';
import {Dialog, Cascader} from 'vant';

export default {
    name: "projectCase_useKP",
    components: {
        Screen,
        Cascader
    },
    data() {
        return {
            isZxy: false,
            nTipsNum: 0,
            isSelectCity: false,
            isShowCondition: false, //条件筛选
            mode: 0, //0-列表，1-地图
            isRefreshing: false, //是否下拉刷新状态
            isloading: false, //是否上拉加载状态
            isfinished: false,//是否加载完成
            nCasePage: 0,
            nAllCasepage: 0,//周边案例分页
            arrCaseList: [],
            arrAllCaseList: [], //周边案例
            mapCaseList: [],
            oPicker: {
                colorConfirm: "rgba(33, 51, 102, 1)",
            }, // 三级联动弹窗配置
            nCity: '',
            condition: {},
            nSelectCity: '',
            arrCityList: [],

            map: {},
            oPositionInfo: {},
            nNav: 0,
            arrNav: [{
                className: "active-1",
                iconName: "nav-icon-1",
                id: 1,
                open: false,
                name: "已签约",
                oTotalNum: 0,
            }, {
                className: "active-2",
                iconName: "nav-icon-2",
                id: 2,
                open: false,
                name: "施工中",
                oTotalNum: 0,
            }, {
                className: "active-3",
                iconName: "nav-icon-3",
                id: 3,
                open: false,
                name: "已完工",
                oTotalNum: 0,
            }],
            isUnfoldMapList: false,
            tCensus: '', // 定时器
            scrollTop: 0,

            objFourLngLat: {
                southWest: '',//'西南',
                northEast: '',//'东北',
            },//可视区域四个角的经纬度
        }
    },
    created() {
        this.$store.commit("loadSwitch", true);
        if (this.$route.query.project_uuid) {
            this.addReadNum(this.$route.query.project_uuid, 'case', 'anli_more').then(res => {
                this.$store.commit('loadSwitch', false)
                this.tCensus = setInterval(() => {
                    //统计数据---更多案例
                    this.addReadNum(this.$route.query.project_uuid, 'case', 'anli_more', res)
                }, 5000)
            })
        }

        this.pageInit().then(() => {
            Promise.all([this.getCaseListFun(false)]).then(() => {
                this.$store.commit("loadSwitch", false);
            }).catch(() => {
                this.$store.commit("loadSwitch", false);
            })
        }).catch(() => {
            this.$store.commit("loadSwitch", false);
            Dialog.alert({
                title: '提示',
                message: '获取定位失败，请选择城市',
                confirmButtonText: '去选择',
                confirmButtonColor: '#213265'
            }).then((res) => {
                this.toArea()
            })
        })
    },
    activated() {
        // vConsole.show();
        this.checkZxyFun();
        this.$refs.list.scrollTop = this.scrollTop;
    },
    mounted() {
    },
    beforeRouteLeave(to, from, next) {
        this.scrollTop = this.$refs.list.scrollTop;
        if (this.tCensus) {
            clearInterval(this.tCensus)
            this.tCensus = ''
        }
        next()
    },
    methods: {
        // 统计阅读量
        addReadNum(uuid, type, notice_type, log_id) {
            return new Promise(resolve => {
                let options = {
                    project_uuid: uuid,
                    type: type,
                    notice_type,
                    share_user_id: this.$route.query.share_id
                }
                if (log_id) {
                    options.log_id = log_id
                }
                readNum(options, false).then(res => {
                    resolve(res.data.data.result)
                })
            })
        },
        pageInit() {
            return new Promise((resolve, reject) => {
                if (!this.oPositionInfo.latitude && !this.oPositionInfo.longitude) {
                    setTimeout(() => {
                        Promise.race([this.getLocationH5(), this.timeOutFun()]).then(() => {
                            resolve()
                        }).catch((err) => {
                            console.log(err)
                            return;
                            this.map = {};
                            // 获取地址三级联动数据
                            getTree().then((res) => {
                                let arrTree = res.data.data.result;
                                console.log(arrTree[0])
                                // this.arrTreelist = arrTree;
                                this.arrCityList = [];
                                let arrProvince = arrTree[0];
                                arrProvince.forEach((it) => {
                                    it["text"] = it.name;
                                    it["value"] = it.name;
                                    if (arrTree[it.id].length) {
                                        it["children"] = arrTree[it.id];
                                        it.children.forEach((sit) => {
                                            sit["text"] = sit.name;
                                            sit["value"] = sit.name;
                                            // sit['children'] = arrTree[sit.id]
                                        });
                                    }
                                });
                                // arrProvince.splice(0,1);
                                this.arrCityList = arrProvince.splice(1);
                                console.log(this.arrCityList)
                                reject()
                            });
                        })

                    }, 400)
                } else {
                    resolve()
                }
            })
        },
        /*pageInit() {
            return new Promise((resolve, reject) => {
                // 获取微信签名，获取地理位置
                let confit = {
                    share_friend_title:
                        "A.O.史密斯AI-LiNK冷暖风水专业集成-项目案例",
                    share_friend_desc: "中央空调·采暖·新风·全屋用水",
                    share_img_url:
                        "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_two_img.png",
                    share_link: window.location.href,
                };
                getWxSingleConfig(confit).then(res => {
                    if (!this.oPositionInfo.latitude && !this.oPositionInfo.longitude) {
                        setTimeout(() => {
                            Promise.race([this.getLocationH5(), this.timeOutFun()]).then(() => {
                                resolve()
                            }).catch(() => {
                                this.map = {};
                                // 获取地址三级联动数据
                                getTree().then((res) => {
                                    let arrTree = res.data.data.result;
                                    console.log(arrTree[0])
                                    // this.arrTreelist = arrTree;
                                    this.arrCityList = [];
                                    let arrProvince = arrTree[0];
                                    arrProvince.forEach((it) => {
                                        it["text"] = it.name;
                                        it["value"] = it.name;
                                        if (arrTree[it.id].length) {
                                            it["children"] = arrTree[it.id];
                                            it.children.forEach((sit) => {
                                                sit["text"] = sit.name;
                                                sit["value"] = sit.name;
                                                // sit['children'] = arrTree[sit.id]
                                            });
                                        }
                                    });
                                    // arrProvince.splice(0,1);
                                    this.arrCityList = arrProvince.splice(1);
                                    console.log(this.arrCityList)
                                    reject()
                                });
                            })

                        }, 400)
                    } else {
                        resolve()
                    }
                }).catch((err) => {
                    /!*let msg = 'JSAPI授权失败：' + JSON.stringify(err || {})
                    window.alert(msg)*!/
                    // 获取地址三级联动数据
                    getTree().then((res) => {
                        let arrTree = res.data.data.result;
                        console.log(arrTree[0])
                        // this.arrTreelist = arrTree;
                        this.arrCityList = [];
                        let arrProvince = arrTree[0];
                        arrProvince.forEach((it) => {
                            it["text"] = it.name;
                            it["value"] = it.name;
                            if (arrTree[it.id].length) {
                                it["children"] = arrTree[it.id];
                                it.children.forEach((sit) => {
                                    sit["text"] = sit.name;
                                    sit["value"] = sit.name;
                                    // sit['children'] = arrTree[sit.id]
                                });
                            }
                        });
                        // arrProvince.splice(0,1);
                        this.arrCityList = arrProvince.splice(1);
                        console.log(this.arrCityList)
                        reject()
                    });
                });
            })
        },*/
        /**
         * 获取位置信息
         */
        getLocationH5() {
            return new Promise((resolve, reject) => {
                let that = this;
                if (this.$route.query.latng) {
                    let latng = this.$route.query.latng.split(',');
                    this.oPositionInfo = {
                        city: '',
                        province: '',
                        latitude: latng[0],
                        longitude: latng[1]
                    }
                    if (this.oPositionInfo.latitude && this.oPositionInfo.longitude) {
                        geoGetAddress([this.oPositionInfo.longitude, this.oPositionInfo.latitude]).then((address) => {
                            this.oPositionInfo.city = address.regeocode.addressComponent.city;
                            this.oPositionInfo.province = address.regeocode.addressComponent.province;
                            this.nCity = this.oPositionInfo.city;
                            // 获取地址三级联动数据
                            getTree().then((res) => {
                                let arrTree = res.data.data.result;
                                // this.arrTreelist = arrTree;
                                this.oPositionInfo.provinceId = arrTree[0].filter((item) => item.name.includes(this.oPositionInfo.province.substring(0, 2)))[0].id || null;
                                this.oPositionInfo.cityId = arrTree[this.oPositionInfo.provinceId].filter((item) => item.name.includes(this.oPositionInfo.city.substring(0, 2)))[0].id || null;

                                this.arrCityList = [];
                                let arrProvince = arrTree[0];
                                arrProvince.forEach((it) => {
                                    it["text"] = it.name;
                                    it["value"] = it.name;
                                    if (arrTree[it.id].length) {
                                        it["children"] = arrTree[it.id];
                                        it.children.forEach((sit) => {
                                            sit["text"] = sit.name;
                                            sit["value"] = sit.name;
                                            // sit['children'] = arrTree[sit.id]
                                        });
                                    }
                                });
                                // arrProvince.splice(0, 1);
                                this.arrCityList = arrProvince.splice(1);
                                resolve()
                            });
                        })

                    } else {
                        reject()
                    }
                } else {
                    MapLoader().then((AMap) => {
                        AMap.plugin('AMap.Geolocation', function () {
                            var geolocation = new AMap.Geolocation({
                                enableHighAccuracy: true, //  是否使用高精度定位，默认:true
                                timeout: 4000, //  超过4秒后停止定位，默认：无穷大
                                maximumAge: 60000, // 定位结果缓存60秒，默认：0
                                // 是否禁止使用IP定位，默认值为0，可选值0-3
                                //0: 可以使用IP定位 1: 手机设备禁止使用IP定位 2: PC上禁止使用IP定位 3: 所有终端禁止使用IP定位
                                noIpLocate: 0,
                                //是否禁止使用浏览器Geolocation定位，默认值为0，可选值0-3
                                // 0: 可以使用浏览器定位  1: 手机设备禁止使用浏览器定位  2: PC上禁止使用浏览器定位  3: 所有终端禁止使用浏览器定位
                                noGeoLocation: 0,
                            })
                            geolocation.getCurrentPosition(function (status, result) {
                                if (status == 'complete') {
                                    that.oPositionInfo = {
                                        city: '',
                                        province: '',
                                        latitude: result.position.lat,
                                        longitude: result.position.lng
                                    }
                                    if (that.oPositionInfo.latitude && that.oPositionInfo.longitude) {
                                        geoGetAddress([that.oPositionInfo.longitude, that.oPositionInfo.latitude]).then((address) => {
                                            that.oPositionInfo.city = address.regeocode.addressComponent.city;
                                            that.oPositionInfo.province = address.regeocode.addressComponent.province;
                                            that.nCity = that.oPositionInfo.city;
                                            // 获取地址三级联动数据
                                            getTree().then((res) => {
                                                let arrTree = res.data.data.result;
                                                // this.arrTreelist = arrTree;
                                                that.oPositionInfo.provinceId = arrTree[0].filter((item) => item.name.includes(that.oPositionInfo.province.substring(0, 2)))[0].id || null;
                                                that.oPositionInfo.cityId = arrTree[that.oPositionInfo.provinceId].filter((item) => item.name.includes(that.oPositionInfo.city.substring(0, 2)))[0].id || null;
                                                that.arrCityList = [];
                                                let arrProvince = arrTree[0];
                                                arrProvince.forEach((it) => {
                                                    it["text"] = it.name;
                                                    it["value"] = it.name;
                                                    if (arrTree[it.id].length) {
                                                        it["children"] = arrTree[it.id];
                                                        it.children.forEach((sit) => {
                                                            sit["text"] = sit.name;
                                                            sit["value"] = sit.name;
                                                            // sit['children'] = arrTree[sit.id]
                                                        });
                                                    }
                                                });
                                                // arrProvince.splice(0, 1);
                                                that.arrCityList = arrProvince.splice(1);
                                                resolve()
                                            });
                                        })
                                    } else {
                                        reject()
                                    }
                                } else {
                                    console.log(result, 'result')
                                    that.$store.commit("loadSwitch", false);
                                    Dialog.alert({
                                        title: '提示',
                                        message: '自动定位失败请手动确认位置信息!',
                                        confirmButtonText: '选择位置',
                                        confirmButtonColor: '#213265'
                                    }).then((res) => {
                                        window.location.href = `https://apis.map.qq.com/tools/locpicker?search=1&type=0&backurl=${window.location.href}&key=UW3BZ-J2JRA-XXIKC-CGQBX-ZC4Y6-NJFB5&referer=aosms&referer=myapp`;
                                    })
                                }
                            });
                        })

                    })
                }
            });
        },
        getWxGetLocationH5() {
            return new Promise((resolve, reject) => {
                wxGetLocationH5()
                    .then((addresInfo) => {
                        console.log('addresInfo', addresInfo)
                        this.oPositionInfo = addresInfo;
                        this.nCity = this.oPositionInfo.city;

                        if (this.oPositionInfo.latitude && this.oPositionInfo.longitude) {
                            // 获取地址三级联动数据
                            getTree().then((res) => {
                                let arrTree = res.data.data.result;
                                // this.arrTreelist = arrTree;

                                this.oPositionInfo.provinceId = arrTree[0].filter((item) =>
                                    item.name.includes(
                                        this.oPositionInfo.province.substring(0, 2)
                                    )
                                )[0].id || null;
                                this.oPositionInfo.cityId = arrTree[this.oPositionInfo.provinceId].filter((item) =>
                                    item.name.includes(
                                        this.oPositionInfo.city.substring(0, 2)
                                    )
                                )[0].id || null;

                                this.arrCityList = [];
                                let arrProvince = arrTree[0];
                                arrProvince.forEach((it) => {
                                    it["text"] = it.name;
                                    it["value"] = it.name;
                                    if (arrTree[it.id].length) {
                                        it["children"] = arrTree[it.id];
                                        it.children.forEach((sit) => {
                                            sit["text"] = sit.name;
                                            sit["value"] = sit.name;
                                            // sit['children'] = arrTree[sit.id]
                                        });
                                    }
                                });
                                // arrProvince.splice(0, 1);
                                this.arrCityList = arrProvince.splice(1);
                                resolve()
                            });
                        } else {
                            reject()
                        }
                    })
                    .catch(() => {
                        reject()
                    });
            })
        },
        timeOutFun() {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    reject()
                }, 60000)
            })
        },
        checkZxyFun() {
            return new Promise((resolve, reject) => {
                checkZxy().then((res) => {
                    this.isZxy = res.data.data.result;
                    if (this.isZxy) {
                        getTipsNum().then((tips) => {
                            this.nTipsNum = tips.data.data.result.num
                            resolve()
                        })
                    } else {
                        resolve()
                    }
                })
            })
        },
        //切换展示模式
        cutMode() {
            if (this.mode) {
                this.mode = 0;
                // this.$store.commit("loadSwitch", true);
                // this.getCaseListFun().then(() => {
                //     this.$store.commit("loadSwitch", false);
                // })
            } else {
                this.mode = 1;
                this.initMap();
            }
        },
        toCondition() {
            this.mode = 0;
            this.isShowCondition = !this.isShowCondition;
        },
        toArea() {
            // this.$refs.picker.show();
            this.isSelectCity = !this.isSelectCity;

            if (!this.isSelectCity && !this.oPositionInfo.latitude && !this.oPositionInfo.longitude) {
                Dialog.alert({
                    title: '提示',
                    message: '请先选择城市',
                    confirmButtonText: '去选择',
                    confirmButtonColor: '#213265'
                }).then((res) => {
                    this.toArea()
                })
            }
        },
        onCondition(condition) {
            console.log(condition)
            this.condition = condition;
            this.toCondition();
            this.arrCaseList = [];
            this.getCaseListFun(true)
        },
        onListRefresh() {
            console.log('刷新')
            this.isfinished = false;
            this.nCasePage = 0;
            this.nAllCasepage = 0;
            this.arrAllCaseList = [];
            this.getCaseListFun()
        },
        onListLoad() {
            console.log('加载')
            if (this.arrAllCaseList.length > 0) {
                this.nAllCasepage = this.nAllCasepage + 1;
                this.getAllCaseListFun(true)
            } else {
                this.nCasePage = this.nCasePage + 1;
                this.getCaseListFun()
            }
        },
        getCaseListFun(isShowLoad = true) {
            if (isShowLoad) {
                this.$store.commit("loadSwitch", true);
            }
            return new Promise((resolve, reject) => {
                let param = {
                    ...this.condition,
                    cityId: this.oPositionInfo.cityId,
                    longitude: this.oPositionInfo.longitude,
                    latitude: this.oPositionInfo.latitude,
                    page: this.nCasePage,
                    row: 10
                }
                getCaseList(param).then((res) => {
                    let lists = res.data.data.result.lists || [];
                    let total = res.data.data.result.total;
                    this.isloading = false;
                    this.isRefreshing = false;
                    if (this.nCasePage == 0) {
                        this.arrCaseList = []
                    }
                    lists.forEach((it) => {
                        if (it.images && it.images.length > 0) {
                            it.images.forEach((imgs) => {
                                imgs.img_url = encodeURI(imgs.img_url);
                            })
                        }
                    })
                    this.arrCaseList.push(...lists)


                    if (this.arrCaseList.length == 0 || total == this.arrCaseList.length) {
                        this.nAllCasepage = 0;
                        this.arrAllCaseList = [] //周边案例
                        this.getAllCaseListFun(isShowLoad).then(() => {
                            resolve()
                        });
                    } else {
                        // if (this.arrCaseList.length >= total) {
                        //     this.isfinished = true;
                        // }
                        if (isShowLoad) {
                            this.$store.commit("loadSwitch", false);
                        }
                        resolve()
                    }
                })
            })
        },
        getAllCaseListFun(isShowLoad) {
            if (isShowLoad) {
                this.$store.commit("loadSwitch", true);
            }
            return new Promise((resolve, reject) => {
                let param = {
                    ...this.condition,
                    cityId: this.oPositionInfo.cityId,
                    longitude: this.oPositionInfo.longitude,
                    latitude: this.oPositionInfo.latitude,
                    page: this.nAllCasepage,
                    row: 10
                }
                getAllCaseList(param).then((res) => {
                    let lists = res.data.data.result.lists || [];
                    let total = res.data.data.result.total;
                    this.isloading = false;
                    this.isRefreshing = false;
                    if (this.nAllCasepage == 0) {
                        this.arrAllCaseList = []
                    }

                    lists.forEach((it) => {
                        if (it.images && it.images.length > 0) {
                            it.images.forEach((imgs) => {
                                imgs.img_url = encodeURI(imgs.img_url);
                            })
                        }
                    })

                    this.arrAllCaseList.push(...lists)


                    if (this.arrAllCaseList.length >= total) {
                        this.isfinished = true;
                    }

                    if (isShowLoad) {
                        this.$store.commit("loadSwitch", false);
                    }
                    resolve()
                })
            })
        },
        confirmCity(res) {
            let data = res.selectedOptions;
            console.log(data)
            const that = this;
            this.$store.commit("loadSwitch", true);
            geoGetLocation(data[0].value + data[1].value)
                .then((result) => {
                    //  console.log(result.geocodes[0].location);
                    that.oPositionInfo.city = data[0].value;
                    that.oPositionInfo.cityId = data[1].id;

                    that.nCity = that.oPositionInfo.city;
                    that.oPositionInfo.longitude = result.geocodes[0].location.lng;
                    that.oPositionInfo.latitude = result.geocodes[0].location.lat;

                    // 获取案例总数
                    // that.getProjectTotalNum();

                    // that.$store.commit("loadSwitch", false);
                    this.isSelectCity = false;
                    if (this.mode) {
                        that.initMap();
                    } else {
                        // 获取地图数据
                        that.getMapDataFun();
                        // 获取对应省市的案例列表
                        that.getCaseListFun();
                    }
                })
                .catch((err) => {
                    this.isSelectCity = false
                    this.$toast({
                        message: "无案例数据！",
                        position: "bottom",
                        duration: 1200,
                    });
                    //  console.log(err, "err");
                    that.$store.commit("loadSwitch", false);
                });
        },
        cancelCity() {
            if (!this.oPositionInfo.latitude && !this.oPositionInfo.longitude) {
                Dialog.alert({
                    title: '提示',
                    message: '请先选择城市',
                    confirmButtonText: '去选择',
                    confirmButtonColor: '#213265'
                }).then((res) => {
                    this.toArea()
                })
            }
        },
        //初始化地图
        /*initMap() {
            this.$store.commit("loadSwitch", true);
            MapLoader().then((AMap) => {
                //  console.log("地图加载成功");
                this.map = new AMap.Map("container", {
                    center: [this.oPositionInfo.longitude, this.oPositionInfo.latitude],
                    zoom: 10,
                    showIndoorMap: false, // 是否在有矢量底图的时候自动展示室内地图，PC默认true,移动端默认false
                    resizeEnable: true, //是否监控地图容器尺寸变化，默认值为false
                    dragEnable: true, // 地图是否可通过鼠标拖拽平移，默认为true
                    keyboardEnable: false, //地图是否可通过键盘控制，默认为true
                    doubleClickZoom: false, // 地图是否可通过双击鼠标放大地图，默认为true
                    zoomEnable: true, //地图是否可缩放，默认值为true
                    rotateEnable: false, // 地图是否可旋转，3D视图默认为true，2D视图默认false
                });
                Promise.all([this.getMapDataFun(), this.getMapPlotsFun(0)]).then(() => {
                    this.$store.commit("loadSwitch", false);
                })
            }, (e) => {
                console.log("地图加载失败", e);
            });
        },*/
        // 初始化地图
        initMap() {
            const that = this;
            MapLoader().then(
                (AMap) => {
                    //  console.log("地图加载成功");
                    this.map = new AMap.Map("container", {
                        center: [that.oPositionInfo.longitude, that.oPositionInfo.latitude],
                        expandZoomRange: true,
                        zoom: 10,
                        showIndoorMap: true, // 是否在有矢量底图的时候自动展示室内地图，PC默认true,移动端默认false
                        resizeEnable: true, //是否监控地图容器尺寸变化，默认值为false
                        dragEnable: true, // 地图是否可通过鼠标拖拽平移，默认为true
                        keyboardEnable: true, //地图是否可通过键盘控制，默认为true
                        doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图，默认为true
                        zoomEnable: true, //地图是否可缩放，默认值为true
                        rotateEnable: false, // 地图是否可旋转，3D视图默认为true，2D视图默认false
                        draggable: true,
                        scrollWheel: true,
                    });
                    that.objFourLngLat.southWest = that.map.getBounds().getSouthWest()
                    that.objFourLngLat.northEast = that.map.getBounds().getNorthEast()
                    console.log(that.objFourLngLat, '可是区域经纬度')
                    that.map.on("complete", function () {
                        that.$store.commit("loadSwitch", true);
                        Promise.all([that.getMapDataFun(), that.getMapPlotsFun(0)]).then(() => {
                            that.$store.commit("loadSwitch", false);
                        })
                    });
                    let moveendTimerId = null;
                    // 地图移动结束
                    that.map.on("moveend", function (e) {
                        if (moveendTimerId) {
                            clearTimeout(moveendTimerId)
                            moveendTimerId = null;
                        }
                        moveendTimerId = setTimeout(() => {
                            that.$store.commit("loadSwitch", true);
                            // 获取iot总数
                            that.objFourLngLat.southWest = that.map.getBounds().getSouthWest()
                            that.objFourLngLat.northEast = that.map.getBounds().getNorthEast()
                            Promise.all([that.getMapPlotsFun(that.nNav)]).then(() => {
                                that.$store.commit("loadSwitch", false);
                            })
                        }, 500)
                    })

                    let zoomendTimerId = null;
                    that.map.on('zoomend', function (e) {
                        if (zoomendTimerId) {
                            clearTimeout(zoomendTimerId)
                            zoomendTimerId = null;
                        }
                        zoomendTimerId = setTimeout(() => {
                            that.$store.commit("loadSwitch", true);
                            // 获取iot总数
                            that.objFourLngLat.southWest = that.map.getBounds().getSouthWest()
                            that.objFourLngLat.northEast = that.map.getBounds().getNorthEast()
                            Promise.all([that.getMapPlotsFun(that.nNav)]).then(() => {
                                that.$store.commit("loadSwitch", false);
                            })
                        }, 500)
                    });
                },
                (e) => {
                    //  console.log("地图加载失败", e);
                }
            );
        },
        // 创建标注
        createMarker(list, state) {
            console.log(list, state, 'createMarker')
            this.map.clearMap();
            const that = this;
            const arrMarker = list.map((item) => {
                let markerContent = null;
                if (Number(state) == 1) {
                    markerContent =
                        '<div class="ant-map-marker">' +
                        '<img src="' +
                        require("@/assets/images/ant/map/icon_red.png") +
                        '">' +
                        '<div class="text">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else if (Number(state) == 2) {
                    markerContent =
                        '<div class="ant-map-marker">' +
                        '<img src="' +
                        require("@/assets/images/ant/map/icon_violet.png") +
                        '">' +
                        '<div class="text">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else if (Number(state) == 3) {
                    markerContent =
                        '<div class="ant-map-marker">' +
                        '<img src="' +
                        require("@/assets/images/ant/map/icon_blue.png") +
                        '">' +
                        '<div class="text">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else {
                    markerContent =
                        '<div class="ant-map-marker">' +
                        '<img src="' +
                        require("@/assets/images/ant/map/icon_green.png") +
                        '">' +
                        '<div class="text">' +
                        item.total +
                        "</div>" +
                        "</div>";
                }
                const marker = new AMap.Marker({
                    position: new AMap.LngLat(
                        Number(item.longitude),
                        Number(item.latitude)
                    ),
                    content: markerContent,
                    offset: new AMap.Pixel(-13, -30),
                    animation: "AMAP_ANIMATION_DROP", // AMAP_ANIMATION_BOUNCE
                });

                // 绑定点击事件
                marker.on("click", function ({lat, lng, type, target}) {
                    that.$store.commit("loadSwitch", true);
                    // 当前标注变色
                    // target.setContent('<div class="custom-content-marker">' +
                    //     '<img src=' + that.oIcon.iconYellow + '>' +
                    //     '<div class="close-btn">' + item.topic_total + '</div>' +
                    //     '</div>')
                    // that.getMapCaseList(item.id).then(() => {
                    that.getMapCaseList(item.plot_ids).then(() => {
                        that.$store.commit("loadSwitch", false);
                        that.isUnfoldMapList = true;
                    });
                });

                return marker;
            });

            // 当前位置标注
            let markerContentNow =
                '<div class="ant-map-marker">' +
                '<img src="' +
                require("@/assets/images/icon_yellow.png") +
                '">' +
                "</div>";
            let markerNow = new AMap.Marker({
                position: new AMap.LngLat(this.oPositionInfo.longitude, this.oPositionInfo.latitude),
                content: markerContentNow,
                offset: new AMap.Pixel(-13, -30),
                animation: "AMAP_ANIMATION_DROP", // AMAP_ANIMATION_BOUNCE
            });
            arrMarker.splice(0, 0, markerNow);
            this.map.add(arrMarker);
        },
        navChange(i) {
            this.arrNav.forEach((it, index) => {
                if (i == index) {
                    it.open = !it.open;
                    if (it.open) {
                        this.$store.commit("loadSwitch", true);
                        this.getMapPlotsFun(it.id).then(() => {
                            this.$store.commit("loadSwitch", false);
                        })
                    }
                } else {
                    it.open = false
                }
            });
        },
        getMapDataFun() {
            return new Promise((resolve, reject) => {
                getMapData({
                    city_id: this.oPositionInfo.cityId,
                }).then((res) => {
                    let data = res.data.data.result;
                    console.log(data, 'data');
                    this.arrNav.forEach((it) => {
                        it.open = false;
                        switch (it.id) {
                            case 1:
                                it.oTotalNum = data.sign_num;
                                break;
                            case 2:
                                it.oTotalNum = data.build_num;
                                break;
                            case 3:
                                it.oTotalNum = data.finish_num;
                                break;
                        }
                    })
                    resolve()
                })
            })
        },
        getMapPlotsFun(state = 0) {
            this.nNav = state;
            return new Promise((resolve, reject) => {
                getMapPlots({
                    longitude: this.oPositionInfo.longitude,
                    latitude: this.oPositionInfo.latitude,
                    distance: '',
                    'lon-left-bottom': this.objFourLngLat.southWest.lng,
                    'lat-left-bottom': this.objFourLngLat.southWest.lat,
                    'lon-right-top': this.objFourLngLat.northEast.lng,
                    'lat-right-top': this.objFourLngLat.northEast.lat,
                    state: this.nNav
                }).then((res) => {
                    let data = res.data.data.result;
                    if (data.list && data.list.length > 0) {
                        this.createMarker(data.list || [], state);
                        this.getMapCaseList(data.list[0].plot_ids).then(() => {
                            resolve()
                        })
                    } else {
                        this.createMarker([], state);
                        resolve()
                    }
                })
            })
        },
        getMapCaseList(ids = []) {
            console.log(ids.join(','), 'ids.join(\',\')')
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    getMapList({
                        plot_ids: ids.join(','),
                        state: this.nNav
                    }).then((res) => {
                        let data = res.data.data.result;
                        data.lists.forEach((it) => {
                            if (it.images && it.images.length > 0) {
                                it.images.forEach((imgs) => {
                                    imgs.img_url = encodeURI(imgs.img_url);
                                })
                            }
                        })
                        this.mapCaseList = data.lists;
                        resolve()
                    })
                }, 2000)
            })
        },
        toMapList() {
            this.isUnfoldMapList = !this.isUnfoldMapList;
        },
        toCase(item) {
            var that = this;
            that.$router.push({
                path: `/project/v3/case/details?id=${item.id}&mode=1&ut_source=qw_h5`
            })
            /*var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                if (ua.match(/WxWork/i) == "wxwork") {
                    //企业微信环境下
                    if (wx?.miniProgram?.getEnv) {
                        wx.miniProgram.getEnv(function (res) {
                            if (res.miniprogram) {
                                // 小程序环境下逻辑
                                wx.miniProgram.navigateTo({
                                    url: `/pages/antdetailsv3/index?id=${item.id}&qywxUserId=${that.$storage.getStorage("user_id")}&mode=1&title=${item.type}|${item.city}${item.community_name}项目案例&img=${(item.images && item.images.length > 0) ? item.images[0].img_url : ''}`,
                                });
                            } else {
                                //非小程序环境下逻辑
                                that.$router.push({
                                    path: `/project/v3/case/details?id=${item.id}&mode=1&ut_source=ai_heating`
                                })
                            }
                        });
                    } else {
                        that.$router.push({
                            path: `/project/v3/case/details?id=${item.id}&mode=1&ut_source=ai_heating`
                        })
                    }
                } else {
                    //判断是否是微信环境
                    //微信环境
                    wx.miniProgram.getEnv(function (res) {
                        if (res.miniprogram) {
                            // 小程序环境下逻辑
                            wx.miniProgram.navigateTo({
                                url: `/pages/antdetailsv3/index?id=${item.id}&qywxUserId=${that.$storage.getStorage("user_id")}&mode=1&title=${item.type}|${item.city}${item.community_name}项目案例&img=${(item.images && item.images.length > 0) ? item.images[0].img_url : ''}`,
                            });
                        } else {
                            that.$router.push({
                                path: `/project/v3/case/details?id=${item.id}&mode=1&ut_source=praise_map`
                            })
                        }
                    });
                }
            } else {
                that.$router.push({
                    path: `/project/v3/case/details?id=${item.id}&mode=1&ut_source=praise_map`
                })
            }*/
        },
        toListTips() {
            this.$router.push('/project/v3/tips/index')
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
